import {
    Stack,
    Typography,
    TextField,
    MenuItem,
    FormControlLabel,
    Switch,
    Button,
} from "@mui/material";

export default function ReceiptSettings() {
    return (
        <>
            <Typography
                sx={{
                    fontSize: 24,
                    fontWeight: 700,
                    mb: 0.5,
                }}
            >
                Receipt Settings
            </Typography>

            <Typography sx={{ color: "#777", mb: 4 }}>
                Customize receipt printing
            </Typography>

            <Stack spacing={3}>
                <TextField
                    select
                    fullWidth
                    label="Paper Size"
                    defaultValue="80mm"
                >
                    <MenuItem value="58mm">
                        58mm
                    </MenuItem>

                    <MenuItem value="80mm">
                        80mm
                    </MenuItem>
                </TextField>

                <FormControlLabel
                    control={<Switch />}
                    label="Auto Print Receipt"
                />

                <FormControlLabel
                    control={<Switch />}
                    label="Show Barcode"
                />

                <Button
                    variant="contained"
                    sx={{
                        width: "fit-content",
                        backgroundColor: "#111",
                        borderRadius: 3,
                        textTransform: "none",
                    }}
                >
                    Save Changes
                </Button>
            </Stack>
        </>
    );
}